import React from "react";
import Box from "../Box";
import Text from "../Text";

export type DialogProps = {
  text: string;
  color?: string;
  borderBottom?: string;
  borderTop?: string;
  background?: string;
};

const Dialog: React.FC<DialogProps> = ({
  text,
  color = "grayDarkest",
  borderBottom = "default",
  borderTop = "none",
  background = "white",
}) => {
  return (
    <Box p="s" borderBottom={borderBottom} borderTop={borderTop} background={background}>
      <Text ml="20px" font="ui.smallBold" color={color}>
        {text}
      </Text>
    </Box>
  );
};

export default Dialog;
